import React, { useEffect, useState, useRef } from "react";
import { Placeholder } from "react-bootstrap";
import request from "../../Requests/requests";
import '../../textEditor/quill.bubble.css';
import '../index.css';
import '../EditTaskModal/EditModalTask.css'
import { modalWindowContext } from "../../Context/modalWindowContext";
import ModalWindowSaveChanges from "../ModalWindowSaveChanges";
import { useOutsideClick } from "../../customHooks/useOutsideClick";
import { addCheckList } from "../../asyncActions/addCheckList";
import { addRunTime } from "../../asyncActions/RunTimeActions/addRunTime";
import { editTodo } from "../../asyncActions/editTodos";
import alienTaskGif from "../static/alienTask.gif";
import { ReactComponent as HideBtnSVG } from "../../icons/svg/ModalChangingTask/hidebtn.svg";
import { ReactComponent as TaskKebabSVG } from "../../icons/svg/ModalChangingTask/task-menu-icon.svg"
import { ReactComponent as TransferSVG } from "../../icons/svg/ModalChangingTask/TitleImg/transferIcon.svg";
import Modal from 'react-bootstrap/Modal';
import CheckList from "../../ChekList/CheckList";
import DDSelectPriority from "../../DropDownMenu/SelectPriority/DDSelectPriority";
import DDSelectTags from "../../DropDownMenu/SelectTags/DDSelectTags";
import DDSelectTaskMenu from "../../DropDownMenu/SelectTaskMenu/DDSelectTaskMenu";
import DDSelectActionToCheckList from "../../DropDownMenu/SelectActionToCheckList/DDSelectActionToCheckList";
import ModalWindowCloseWarning from "../ModalWindowCloseWarning";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader/Lodaer";
import TaskStopWatch from "../../TaskTimer/TaskStopWatch";
import { timerPush } from "../../asyncActions/TimerActions/timerPush";
import ConverterUTC from "../../ConverterUTC/ConverterUTC";
import ToolTipComponent from "../../UIcomponents/Tooltips/Tooltip";
import { useConnectionHubContext } from "../../Context/connectionHubContext";
import DropDownSelectOfDate from "../../DropDownMenu/SelectDateCalendar/SelectDateCalendar";
import differenceOfObjects from "../../utils/getDifferenceOfObjects";
import CustomList from "../../UIcomponents/Lists/CustomList";
import { removeTodo } from "../../asyncActions/removeTodos";
import getDateObject from "../../utils/getDateObject";
import ReminderSelect from "../../DropDownMenu/SelectReminder/ReminderSelect";
import ModalWindow from "../ModalWindow/ModalWindow";
import Button from "../../UIcomponents/Button/Button";
import { ReactComponent as MyDay } from "../../icons/svg/ModalChangingTask/TitleImg/myDay.svg";
import { ReactComponent as Incoming } from "../../icons/svg/submenu_ic/filled-active.svg";
import { ReactComponent as Completed } from "../../icons/svg/reset-pswd-accept.svg";
import { ReactComponent as Calendar } from "../../icons/svg/submenu_ic/calendar-active.svg";
import { ReactComponent as Removed } from "../../icons/svg/remove-task-hover.svg";
import { ReactComponent as Repeat} from "../../DropDownMenu/SelectRepeatTemplate/static/repeatTemplate_icon.svg"
import { ReactComponent as Plus } from "../../Tags/static/plus-plate.svg";
import { getCheckList } from "../../asyncActions/getCheckList";
import { useOnlineStatus } from "../../customHooks/useOnlineStatus";






export function getURLPath(path) {
  if (!path || path[0] !== '/') return '/';
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  if (/^\/\d+$/.test(path)) return '/';
  const idx = path.indexOf('/', 1);
  return idx === -1 ? path : path.substring(0, idx);
}

const EditModalTask = ({ updateRunTimeFromTask, disabled, modalTitleImg, editTaskModalIcon, ...props }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [taskData, setTaskData] = useState({
    id: null,
    userId: null,
    title: null,
    description: null,
    isCompleted: false,
    isDelete: false,
    isRepit: false,
    priority: null,
    hours: null,
    minutes: null,
    date: null,
    time: null,
    runTime: 0,
    isOpened: false,
    tags: [],
    repitPeriod: null,
    templateTime: '',
    intervalType: 0,
    interval: 1,
    selectedWeekDays: '',
    selectedMonthDays: '',
    endType: 0,
    dateEnd: '',
    repitCount: 1,
    isCreatedAfterCompited: false,
    notificationType: 4
  });
  const [taskDeclaration, setTaskDeclaration] = useState({title: '', description: ''});
  const [unchangedTitle, setUnchangedTitle] = useState();
  const [unchangedDescription, setunchangedDescription] = useState();
  const [runTimeTask, setRunTimeTask] = useState(0);
  const [loading, setLoading] = useState(true);
  const [alienTask, setAlienTask] = useState(false);
  const checkList = useSelector(state => state.checkList.checkList);
  const settingsUser = useSelector(state => state.settings.settings)
  const stopWatchesData = useSelector(state => state.stopWatchesData.stopWatchesData);
  const [date, setDate] = useState();
  const [taskDate, setTaskDate] = useState()
  const [initialTask, setInitialTask] = useState();
  const [actionArray, setActionArray] = useState();
  const [modalShowCheck, setModalShowCheck] = useState(false);
  const [flag, setFlag] = useState(false);
  const prodHidden = process.env.REACT_APP_IS_DEV === 'true';
  const [checkListTitle, setCheckListTitle] = useState('');
  const [hidebtn, setHidebtn] = useState('hideBtn-controls-to-modal');
  const [modalInputContainer, setModalInputContainer] = useState('modal-form__input-container')
  const [modalInputTitle, setModalInputTitle] = useState('modal-form__input-title');
  // const [modalInputDescr, setModalInputDescr] = useState('modal-form__input-descr');
  const [disablePriority, setDisablePriority] = useState(false);
  const [windowScreen, setWindowScreen] = useState(window.screen.width);
  const [currentLenghtOfTitle, setCurrentLenghtOfTitle] = useState();
  const [isActiveCounter, setIsActiveCounter] = useState(false);
  const maxLenghtOfTitle = 150;
  const [formIsChanged, setFormIsChanged] = useState(true);
  const connectionHub = useConnectionHubContext();
  const [warningModal, setWarningModal] = useState(false);
  const [targetOfAction, setTargetOfAction] = useState(0);
  const [dateChanged, setDateChanged] = useState(false);
  const [isDeleteTask, setIsDeleteTask] = useState(false);
  const { isOnline } = useOnlineStatus();
  const [lostConnectionCounter, setLostConnectionCounter] = useState(0);
  const arrList = [{id: 'onlyOne', description: 'Только эту задачу'},
    {id: 'thisAndNext', description: 'Эту и последующие задачи'},
    {id: 'All', description: 'Все задачи', isHidden: dateChanged}
  ]
  const classPriorityArray = ['priority-input-1 priority__input-modalwindow ',
    'priority-input-2 priority__input-modalwindow',
    'priority-input-3 priority__input-modalwindow',
    'priority-input-0 priority__input-modalwindow '
  ]
  const namesPriorityArray = ['Высокий', 'Средний', 'Низкий', 'Без приоритета']
  const [widthInputTag, setWidthInputTag] = useState('207px');
  const [heightInputTag, setHeightInputTag] = useState('25px')
  const [menuActivDatePicker, setMenuActivDatePicker] = useState(false);
  const [menuActivPriorityPicker, setMenuActivPriorityPicker] = useState(false);
  const [menuActivTagsPicker, setMenuActivTagsPicker] = useState(false);
  const [menuActivTask, setMenuActivTask] = useState(false);
  const [controlBtnsCheckList, setControlBtnsCheckList] = useState(false);
  const stylesList = {
    backgroundColor: taskData?.transferCount >= 3 ? '#F8C440' : '#AC98F6', 
    top: '150%', left: windowScreen > 410 ? null : '-50%', 
    right: windowScreen > 410 ? '-5%' : '50%', 
    transform: windowScreen > 410 ? null : 'translateX(-50%)'
}
const stylesListArrow = {
    top: '-8%', 
    right: windowScreen > 410 ? '13%' : '30%'
} 

const stylesContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
}

const refTitle = useRef();
const refDescription = useRef();
const refTransfer = useRef();
const refUlList = useRef();
const refCloseDatePicker = useRef();
const refDataTask = useRef();
useOutsideClick(refCloseDatePicker, () => setMenuActivDatePicker(false), menuActivDatePicker);
const refClosePriorityPicker = useRef();
useOutsideClick(refClosePriorityPicker, () => setMenuActivPriorityPicker(false), menuActivPriorityPicker);
const refCloseTagsPicker = useRef();
useOutsideClick(refCloseTagsPicker, () => setMenuActivTagsPicker(false), menuActivTagsPicker);
const refCloseControlBtnsCheckList = useRef();
useOutsideClick(refCloseControlBtnsCheckList, () => setControlBtnsCheckList(false), controlBtnsCheckList);
const refCloseTaskMenu = useRef();
useOutsideClick(refCloseTaskMenu, () => setMenuActivTask(false), menuActivTask);

  function onInputDiv() {
    if ((refTitle.current) && (refDescription.current)) {
      if ((refTitle.current.innerText !== taskDeclaration.title) || (refDescription.current.innerText !== taskDeclaration.description)) {
        setFormIsChanged(false)
      } else {
        setFormIsChanged(true)
      }
    }
  }

  useEffect(() => {
    setDate(ConverterUTC({ method: 'object', settingsUser: settingsUser }))
  }, [settingsUser])

  useEffect(() => {
    setActionArray(stopWatchesData.find(el => el.taskId === taskData.id))
  }, [stopWatchesData]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    connectionHub.updateHub?.on("Receive", (userId) => {
      getTask()
    });
    return () => {
      connectionHub.updateHub?.off("Receive")
    }
  }, [connectionHub, dispatch]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateTaskList = () => {
    connectionHub.updateHub.invoke("Send", localStorage.getItem('userID'))
      .catch(err => console.error(err));
  }

  const stopTimer = (startTime) => {
    try {
      connectionHub.timerHub?.invoke("Send", localStorage.getItem('userID'), taskData.id, startTime, false)
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const handleUpdateScreenWidth = () => {
      setWindowScreen(window.screen.width)
    }

    window.addEventListener('resize', handleUpdateScreenWidth);

    return () => {
      window.removeEventListener('resize', handleUpdateScreenWidth);
    };
  }, [windowScreen])

useEffect(() => {
  if ((lostConnectionCounter === 1) && isOnline) {
    setLostConnectionCounter(0)
  }
}, [lostConnectionCounter, isOnline])

useEffect(() => {
  if (!isOnline) {
    setLostConnectionCounter(1)
  }
}, [isOnline, lostConnectionCounter])

  async function getTask() {
    try {
      const response = await request.get('/Task/Task', { params: { Id: params.id } })
      if (response.status === 204) {
        console.log('Данные не найдены');
      } else {
        setTaskData(response.data)
        setInitialTask(response.data)
        setTaskDeclaration({title: response.data.title, description: response.data.description})
        setTaskDate(response.data.date)
        setUnchangedTitle(response.data.title)
        setunchangedDescription(response.data.description)
        setActionArray(stopWatchesData.find(actionArr => actionArr.taskId === response.data.id))
        setRunTimeTask(response.data.runTime)
        setLoading(false)
        dispatch(getCheckList(params.id))
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          setLoading(false);
          setAlienTask(true);
        } else {
          console.log(err.response);
        }
      }
    }
  }
  
  useEffect(() => {
    getTask()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  const removeChanges = () => {
    setIsActiveCounter(false);
    setHidebtn('hideBtn-controls-to-modal');
    setDisablePriority(false);
    setFormIsChanged(true);
    // setModalInputDescr('modal-form__input-descr__onblur');
    setModalInputTitle('modal-form__input-title__onblur');
    setModalInputContainer('modal-form__input-container');
    setTaskDeclaration({title: unchangedTitle, description: unchangedDescription})
    refTitle.current.innerText = unchangedTitle;
    refDescription.current.innerText = unchangedDescription;
    setTaskData({
      ...taskData,
      title: unchangedTitle,
      description: unchangedDescription
    })
  }
  
  

  const updateChangesBeforeClosing = () => {
    const differences = differenceOfObjects({originalObj: initialTask, mutableObj: taskData, returnAnswer: 'object'});
    console.log(unchangedTitle, unchangedDescription, taskDeclaration);
    if (getURLPath(location.pathname) === '/statistics') {
      navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
    } else {
      if ((unchangedTitle !== taskDeclaration.title) || (unchangedDescription !== taskDeclaration.description)) {
        handleUpdateTask()
      // }
      // else if ((Object.keys(differences).length === 0) && (unchangedTitle === taskDeclaration.title) || (unchangedDescription === taskDeclaration.description)){
      //   if (getURLPath(location.pathname) === '/task') {
      //     navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   } else {
      //     navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   }
      } else if (((Object.keys(differences).length === 1) && (Object.hasOwn(differences, 'runTime')))) {
        var startTime = new Date().getTime()
          if (actionArray) {
            dispatch(timerPush({ taskId: taskData.id, timerIsActive: false, startTime: startTime }))
          }
          stopTimer(startTime)
          dispatch(addRunTime({ id: taskData.id, seconds: runTimeTask }))
          if (getURLPath(location.pathname) === '/task') {
            navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
          } else {
            navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
          }
      } else if ((Object.keys(differences).length === 1) && (Object.hasOwn(differences, 'isOpened'))) {
        handleUpdateTask()
      } else if ((Object.keys(differences).length === 2) && (Object.hasOwn(differences, 'runTime')) && (Object.hasOwn(differences, 'isOpened'))) {
        handleUpdateTask()
      } else if ((Object.keys(differences).length > 0) && taskData.isRepit) {
        if (Object.hasOwn(differences, 'date')) {
          setDateChanged(true)
        } else {
          setDateChanged(false)
        }
        setTimeout(() => {
          setWarningModal(true)
        }, 50)
      } else if ((unchangedTitle !== taskDeclaration.title) || (unchangedDescription !== taskDeclaration.description)) {
        handleUpdateTask()
      } else {
        handleUpdateTask()
      }
      // if (taskData.isRepit) {
      //   if ((Object.keys(differences).length === 1) && (Object.hasOwn(differences, 'runTime'))) {
      //     var startTime = new Date().getTime()
      //     if (actionArray) {
      //       dispatch(timerPush({ taskId: taskData.id, timerIsActive: false, startTime: startTime }))
      //     }
      //     stopTimer(startTime)
      //     dispatch(addRunTime({ id: taskData.id, seconds: runTimeTask }))
      //     if (getURLPath(location.pathname) === '/task') {
      //       navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //     } else {
      //       navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //     }
      //     // return
      //   }
      //   if ((Object.keys(differences).length === 1) && (Object.hasOwn(differences, 'isOpened'))) {
      //     handleUpdateTask()
      //   }
      //   if ((Object.keys(differences).length === 2) && (Object.hasOwn(differences, 'runTime')) && (Object.hasOwn(differences, 'isOpened'))) {
      //     handleUpdateTask()
      //   }
      //   if (Object.keys(differences).length > 0) {
      //     if (Object.hasOwn(differences, 'date')) {
      //       setDateChanged(true)
      //     } else {
      //       setDateChanged(false)
      //     }
      //     setTimeout(() => {
      //       setWarningModal(true)
      //     }, 50)
      //   } else if ((Object.keys(differences).length === 0) && (taskDeclaration.title === unchangedTitle) && (taskDeclaration.description === unchangedDescription)) {
      //     if (getURLPath(location.pathname) === '/task') {
      //       navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //     } else {
      //       navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //     } 
      //   }
      //   else {
      //     handleUpdateTask()
      //   }
      // } else if (((Object.keys(differences).length === 1) && (Object.hasOwn(differences, 'runTime'))) && (taskDeclaration.title === unchangedTitle) && (taskDeclaration.description === unchangedDescription)) {
      //   var startTime = new Date().getTime()
      //   if (actionArray) {
      //     dispatch(timerPush({ taskId: taskData.id, timerIsActive: false, startTime: startTime }))
      //   }
      //   stopTimer(startTime)
      //   dispatch(addRunTime({ id: taskData.id, seconds: runTimeTask }))
      //   if (getURLPath(location.pathname) === '/task') {
      //     navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   } else {
      //     navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   }
      // } else if ((Object.keys(differences).length === 0) && (taskDeclaration.title === unchangedTitle) && (taskDeclaration.description === unchangedDescription)) {
      //   if (getURLPath(location.pathname) === '/task') {
      //     navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   } else {
      //     navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      //   }
      // }
      // else {
      //   handleUpdateTask()
      // }
    }
  }
  const handleUpdateTask = () => {
    var startTime = new Date().getTime()
      if (actionArray) {
        dispatch(timerPush({ taskId: taskData.id, timerIsActive: false, startTime: startTime }))
      }
      stopTimer(startTime)
      dispatch(addRunTime({ id: taskData.id, seconds: runTimeTask }))
      dispatch(editTodo({
        ...taskData,
        title: modalShowCheck ? refTitle.current.innerText : taskDeclaration.title,
        description: modalShowCheck ? refDescription.current.innerText : taskDeclaration.description,
        isRepit: taskData.repitPeriod > 0 ? true : false,
        isOpened: date.toLocaleDateString() < taskDate ? taskData.isOpened : true,
        updatePageCalendar: location.state?.dateFrom && location.state.dateFrom,
        targetOfAction: targetOfAction
      })).then(() => {
        updateTaskList()
      })
      if (getURLPath(location.pathname) === '/task') {
        navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      } else {
        navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
      }
  }

  const updateWithoutSaving = () => {
    dispatch(addRunTime({ id: actionArray.taskId, seconds: taskData.runTime }));
    stopTimer(new Date().getTime())
  }

  const checkBeforePush = (hidebtn) => {
    if (hidebtn === ' unhideBtn-controls-to-modal') {
      setModalShowCheck(true);
    } else {
      updateChangesBeforeClosing();
    }
  }
  
  const checkLenghtOfTitle = (e) => {
    const unprivilegedEditor = refTitle.current.textContent;
    if (unprivilegedEditor.length < 100) {
      return setIsActiveCounter(false);
    } else if (unprivilegedEditor.length === 100) {
      return setCurrentLenghtOfTitle(unprivilegedEditor.length) & setIsActiveCounter(true);
    } else if ((unprivilegedEditor.length <= maxLenghtOfTitle)) {
      return setCurrentLenghtOfTitle(unprivilegedEditor.length);
    } else if ((unprivilegedEditor.length >= maxLenghtOfTitle && e.key !== 'Backspace')) {
      e.preventDefault()
    }
  }

  const objCheckList = {
    taskId: params.id,
    checkListTitle: checkListTitle,
  }

  const handleSubmitAddCheckListItem = (e) => {
    dispatch(addCheckList(objCheckList));
    setCheckListTitle('')
    e.preventDefault()
  }

  const resizeTagInput = (e) => {
    setWidthInputTag(e.target.scrollWidth + 'px');
    setHeightInputTag(e.target.scrollHeight + 'px');
  }

  const data = {
    warningText: 'Вы внесли изменения, но не сохранили их.',
    closeWarningFromProp: 'modalEditTask',
    changeFunctionProp: updateChangesBeforeClosing,
    stashProp: updateWithoutSaving
  }

  const updateTagList = (e, tag) => {
    setTaskData({
      ...taskData,
      tags: [...taskData.tags, tag]
    })
  }

  const removeTagFromTask = (value) => {
    setTaskData({
      ...taskData,
      tags: taskData.tags.filter((tag) => tag.tagId !== value)
    })
  }

  const updateDataDate = (payload) => {
    setTaskData({
      ...taskData,
      date: payload
    })
  }

  const updateIsOpened = (payload) => {
    setTaskData({
      ...taskData,
      isOpened: payload.isOpened
    })
  }

  const updateDataTime = (payload) => {
    setTaskData({
      ...taskData,
      time: payload
    })
  }

  const updateDataPriority = (payload) => {
    setTaskData({
      ...taskData,
      priority: payload.priority
    })
  }

  const updateRunTime = (payload) => {
    setRunTimeTask(payload.seconds)
  }

  const updateDataRunTime = (payload) => {
    setTaskData({
      ...taskData,
      runTime: payload
    })
  }

  const updateDataHours = (payload) => {
    setTaskData({
      ...taskData,
      hours: payload.hours
    })
  }

  const updateDataMinutes = (payload) => {
    setTaskData({
      ...taskData,
      minutes: payload.minutes
    })
  }

  const updateNotifyType = (payload) => {
    setTaskData({
      ...taskData,
      notificationType: payload
    })
  }

  useEffect(() => {
    updateDataRunTime(runTimeTask)
  }, [runTimeTask]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateRepeatTemplate = (key, value) => {
    setTaskData(prevState => ({
        ...prevState,
        [key]: value
    }))
}

const handleWarningClose = () => {
  setTaskDeclaration({title: initialTask.title, description: initialTask.description})
  setTaskData(initialTask)
  setIsDeleteTask(false)
  setWarningModal(false)
  navigate(`${getURLPath(location.pathname)}`)
}

const handleWarningChange = () => {
  if (isDeleteTask) {
    dispatch(removeTodo(taskData.id))
      .then(() => navigate(`${getURLPath(location.pathname)}`))
  } else {
    handleUpdateTask()
  }
}

const modalData = {
  data: {
      title: `${getURLPath(location.pathname) === '/automation/:id/' ? isDeleteTask ? 'Удалить шаблон' : 'Измененить шаблон': isDeleteTask ? 'Удаление' : 'Изменение '} повторяющейся задачи`,
      description: getURLPath(location.pathname) !== '/automation' ? <CustomList defaultCheck={targetOfAction} onChangeFunc={(index) => setTargetOfAction(index)} listVariant="radio" list={arrList}/> : 
      isDeleteTask ? <p style={{lineHeight: 1.5}}>Больше никаких новых задач по этому шаблону. <br /> Выполненные никуда не денутся - останутся в списке</p> : 
      <p style={{lineHeight: 1.5}}>Будущие задачи подстроятся под новые параметры. <br />Выполненные трогать не будем.</p>,
      buttons: {
          btnAccept: {
              title: `${isDeleteTask ? 'Удалить' : 'Изменить'}`,
              onClickFunc: handleWarningChange
          },
          btnReject: {
              title: 'Отмена',
              onClickFunc: handleWarningClose
          }
      }
  }
}

const closeAlienTask = () => {
  if (getURLPath(location.pathname) === '/task') {
    navigate(`/`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
  } else {
    navigate(`${getURLPath(location.pathname)}`, { state: { dateRange: location.state?.dateRange ? location.state.dateRange : null } }, { require: true })
  }
}

function checkModalHandler(taskData) {
  if (taskData.date || taskData.date === "") {
  const currentDate = new Date().toLocaleDateString()
  const returnData = () => {
    
      function parseDMY(dateStr) {
        const [day, month, year] = dateStr.split('.');
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
      function normalizeToDateOnly(d) {
        const nd = new Date(d);
        nd.setHours(0, 0, 0, 0);
        return nd.getTime();
      }
      if ((taskData.isCompleted && taskData.isDelete) || 
        (!taskData.isCompleted && taskData.isDelete)) {
        return {icon: <Removed style={{width: '14px'}} />, title: 'Удаленные'}
      }
      if (taskData.isCompleted && !taskData.isDelete) {
        return {icon: <Completed style={{width: '14px'}} />, title: 'Выполненные'}
      }
    
      if (normalizeToDateOnly(parseDMY(currentDate)) < normalizeToDateOnly(parseDMY(taskData.date))) {
        return {icon: <Calendar style={{width: '14px'}} />, title: 'Календарь'}
      }
      
      if (taskData.isRepit && (normalizeToDateOnly(parseDMY(currentDate)) > normalizeToDateOnly(parseDMY(taskData.date)))) {
        return {icon: <Repeat style={{width: '14px', fill: '#5932EA'}} />, title: 'Повторяющиеся задачи'}
      }
  
      if (taskData.date === "" || normalizeToDateOnly(parseDMY(currentDate)) > normalizeToDateOnly(parseDMY(taskData.date))) {
        return {icon: <Incoming style={{width: '14px'}} />, title: 'Входящие'}
      }
      if (normalizeToDateOnly(parseDMY(currentDate)) === normalizeToDateOnly(parseDMY(taskData.date))) {
        return {icon: <MyDay style={{width: '14px'}} />, title: 'Мой день'}
      }
  }
  
  const data = returnData()
  return (
    <div style={{display: "flex", alignItems: "center"}}>
    {data.icon}
    <p style={{ marginLeft: '5px', color: '#5932EA', fontSize: '14px' }}>
      {data.title}
    </p>
  </div>
  )
  }
}

const saveChangesCombination = (e) => {
  if (!formIsChanged) {
    if (e.ctrlKey && e.code === 'Enter') {
      setHidebtn('hideBtn-controls-to-modal');
      setDisablePriority(false);
      setFormIsChanged(true);
      setModalInputContainer('modal-form__input-container');
      setUnchangedTitle(taskDeclaration.title);
      setunchangedDescription(taskDeclaration.description);
      setTaskDeclaration({title: refTitle.current.innerText, description: refDescription.current.innerText})
      refTitle.current.blur();
      refDescription.current.blur();
      console.log('fff');
    }
    if (e.ctrlKey && e.code === 'KeyQ') {
      removeChanges();
      refTitle.current.blur();
      refDescription.current.blur();
    }
  }
}

return (
    <>
      {
        alienTask ?
        <ModalWindow freezeEsc={false} updateModalState={closeAlienTask} modalShow={alienTask} logo={true}>
          <div className="alienTask">
            <img className="alienTask__img" loading="lazy" src={alienTaskGif} alt="Чужая задача" />
            <p className="alienTask__title">Пу пу пуууу</p>
            <p className="alienTask__description">возможно, задача не существует {windowScreen > 576 && <br />} или к ней нет разрешения на доступ</p>
            <Button onClickFunc={closeAlienTask} btnType="filled" btnSize="xl" title="Ну, хорошо" />
          </div>
        </ModalWindow> :
        <Modal
          {...taskData}
          show={params.id}
          onHide={() => checkBeforePush(hidebtn)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          title=''>
          {modalShowCheck ? <modalWindowContext.Provider value={[modalShowCheck, setModalShowCheck]}>
            <ModalWindowCloseWarning data={data} />
          </modalWindowContext.Provider>
            : null
          }
          {
            warningModal && 
            <modalWindowContext.Provider value={[warningModal, setWarningModal]}>
              <ModalWindowSaveChanges modalData={modalData}/>
            </modalWindowContext.Provider>
          }
          <>
            <Modal.Header className="modal-header__change-task">
              <div style={{display: "flex", alignItems: "center"}}>
                {editTaskModalIcon}
                <p style={{ marginLeft: '5px', color: '#5932EA', fontSize: '14px' }}>
                  {taskData && checkModalHandler(taskData)}
                </p>
              </div>
              <div ref={refCloseTaskMenu} style={{display: "flex", alignItems: "center"}}>
                {taskData?.transferCount > 0 &&
                <ToolTipComponent
                  active={true}
                  stylesList={stylesList}
                  stylesListArrow={stylesListArrow}
                  tooltipHeader= {taskData?.transferCount >= 3 ? 'Часто переносили задачу на другой день' : 'Сколько раз переносили задачу на другой день'}
                  tooltipDescription= {taskData?.transferCount >= 3 ? `Прокрастинация — не выход, уделите этой задаче больше внимания` : 'Прокрастинация — не выход, отслеживайте, как часто переносите задачи на потом'}>
                    <div ref={refTransfer} 
                      className="transferTaskCount" 
                      onMouseEnter={() => refTransfer.current.style.border = `${taskData?.transferCount >= 3 ? '1px solid #F85640' : '1px solid #A4A8B1'}`}
                      onMouseLeave={() => refTransfer.current.style.border = '1px solid transparent'}>
                      <TransferSVG style={{width: '12px', height: '12px', fill: taskData?.transferCount >= 3 ? '#F85640' : '#A4A8B1'}}/>
                      <p style={taskData?.transferCount >= 3 ? {color: '#F85640'} : {color: '#A4A8B1'}}>{taskData.transferCount}</p>
                    </div>
                </ToolTipComponent>}
                {
                  !loading && 
                  <span className="task-menu-btn" onClick={(e) => {
                    getURLPath(location.pathname) === '/statistics' ? e.preventDefault() : setMenuActivTask(true)}}>
                    <TaskKebabSVG className="taskKebabComponent" />
                  </span>
                } 
                <DDSelectTaskMenu
                  onClickFunc={() => {setIsDeleteTask(!isDeleteTask)
                  setWarningModal(true)}}
                  isRepitTask={taskData.isRepit}
                  updateDataBeforeClose={updateChangesBeforeClosing}
                  active={menuActivTask}
                  setActive={setMenuActivTask}
                  disabled={disabled ? disabled : null}
                  fromRemoved={getURLPath(location.pathname) === '/deleted'}
                  fromCompleted={getURLPath(location.pathname) === '/completed'}
                  taskId={taskData.id} />
                <span className="hide-btn" onClick={() => checkBeforePush(hidebtn)}>
                  <HideBtnSVG className="hideBtnComponent" />
                </span>
              </div>

            </Modal.Header>
            <Modal.Body className="modal-body__change-task">
              <div className="modal-form__container">
                {
                  loading ?
                    <div style={windowScreen > 576 ? {
                      marginLeft: 'auto',
                      display: 'flex',
                      flexDirection: "column",
                      alignItems: 'center',
                      justifyContent: 'center'
                    } :
                      {
                        display: "flex",
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        alignItems: 'center',
                        justifyContent: "center"
                      }}>
                      <Loader className='editTaskloader'></Loader>
                      <div className='footer-separator' style={{ margin: 0, visibility: "hidden" }} />
                    </div> :
                    <div className="description-task-container">
                      <div ref={refDataTask} 
                        className={`${modalInputContainer} + ym-hide-content`} 
                        style={getURLPath(location.pathname) === '/completed' || getURLPath(location.pathname) === '/deleted' ? { pointerEvents: "none" } : null}
                        onKeyDown={(e) => saveChangesCombination(e)}
                        onFocus={() => setModalInputContainer('modal-form__input-container__focus')
                          & setHidebtn(' unhideBtn-controls-to-modal')}>
                        <div contentEditable
                          id="title"
                          suppressContentEditableWarning
                          ref={refTitle}
                          onInput={onInputDiv}
                          className={modalInputTitle}
                          data-placeholder="Название задачи"
                          onFocus={() => setDisablePriority(true)}
                          onKeyDown={(e) => checkLenghtOfTitle(e)}
                        >{taskDeclaration.title}</div>
                        <div contentEditable
                          id="description"
                          suppressContentEditableWarning
                          ref={refDescription}
                          className='modal-form__input-descr'
                          data-placeholder="Описание задачи"
                          onInput={onInputDiv}
                          onFocus={() => setDisablePriority(true)}
                        >{taskDeclaration.description}</div>
                      </div>
                      <div className={hidebtn}>
                        <div>
                          <p className={isActiveCounter ? 'alertCounterLengthOfTitleModal' : 'hide'}>
                            Лимит символов: {currentLenghtOfTitle} из 150
                          </p>
                        </div>
                        <button className="cancel-changes-form"
                          onClick={() => removeChanges()}>
                          Отмена
                        </button>
                        <button className="save-changes-form" disabled={formIsChanged}
                          onClick={() => setHidebtn('hideBtn-controls-to-modal')
                            & setTaskDeclaration({title: refTitle.current.textContent, description: refDescription.current.textContent})
                            & setDisablePriority(false)
                            & setFormIsChanged(true)
                            & setModalInputContainer('modal-form__input-container')
                            & setUnchangedTitle(taskDeclaration.title)
                            & setunchangedDescription(taskDeclaration.description)
                          }>
                          Сохранить
                        </button>
                      </div>
                      <div className='footer-separator' />
                      {
                        windowScreen > 576 ?
                          <div className="checklist-container" style={getURLPath(location.pathname) === '/completed' || getURLPath(location.pathname) === '/deleted' ? { pointerEvents: "none" } : null}>
                            <div className="checklist-box">
                              <div className="checklist-box__info">
                                <p className="checklist-box__title">Чек-лист</p>
                                { checkList.length > 0 && <span className={controlBtnsCheckList ? 'checklist-box__list-arrow active-btn' : 'checklist-box__list-arrow'}
                                  ref={refCloseControlBtnsCheckList}
                                  onClick={(e) =>{getURLPath(location.pathname) === '/statistics' ? e.preventDefault() 
                            : setControlBtnsCheckList(!controlBtnsCheckList)}} />}
                              </div>
                              {
                                checkList.length > 0 && 
                                <DDSelectActionToCheckList active={controlBtnsCheckList}
                                  setActive={setControlBtnsCheckList}
                                  taskId={params.id} />
                              }

                              {params.id === undefined ?
                                null :
                                <CheckList />
                              }

                              {flag ?
                                <form onSubmit={(e) => handleSubmitAddCheckListItem(e)}
                                  className="addchecklist">
                                  <div className="addCheckElement ym-hide-content" style={{ width: widthInputTag, height: heightInputTag }}>
                                    <input type='text'
                                      id='checklist'
                                      name='cheklist'
                                      autoComplete="off"
                                      placeholder='Добавить пункт'
                                      value={checkListTitle}
                                      style={{ width: widthInputTag, height: heightInputTag }}
                                      onInput={(e) => resizeTagInput(e)}
                                      className='addCheckElement__input'
                                      onChange={e => setCheckListTitle(e.target.value)}
                                      autoFocus
                                      required />
                                  </div>
                                  <div className="addchecklist__control-btns">
                                    <Button btnType="filled" btnSize="xs" disabled={checkListTitle === ''} onClickFunc={(e) => handleSubmitAddCheckListItem(e)} title="Добавить"/>
                                    <Button btnType="default" btnSize="xs" onClickFunc={() => setFlag(false)} title="Отмена"/>
                                  </div>
                                </form>
                                :
                                <div >
                                  <Button stylesContainer={stylesContainer} logo={<Plus width={'10px'} height={'10px'}/>} btnType="transparent" btnSize="xs" onClickFunc={(e) => { getURLPath(location.pathname) === '/statistics' ? e.preventDefault() : setFlag(true)}} title="Добавить пункт"/>
                                </div>
                              }
                            </div>
                          </div> : null
                      }
                    </div>
                }
                <div className="priority-container">
                      <div className="priority-time">
                        {
                          loading ? null :
                            <>
                              <div className="priority-time__container">
                                <TaskStopWatch updateRunTime={updateRunTime}
                                  updateDataMinutes={updateDataMinutes}
                                  timeTracking={settingsUser.isTimeTracking}
                                  updateDataHours={updateDataHours}
                                  updateIsOpened={updateIsOpened}
                                  fromToday
                                  taskIdModal={Number(params.id)}
                                  modalShow={params.id ? true : false}
                                  task={taskData}
                                  loading={loading}
                                  runTime={runTimeTask}
                                  updateTaskFunc={getTask}
                                  disabled={taskData.isCompleted || taskData.isDelete || location.state.timerDisabled || new Date().toLocaleDateString() !== taskData.date} />
                              </div>
                            </>
                        }
                      </div>
                  <ul className="priority-list" style={{visibility: loading ? 'hidden' : 'visible'}} ref={refUlList}>
                    <li className="priority-item">
                      <p className="modal-label">Срок выполнения</p>
                      {
                        loading ?
                          <Placeholder animation="wave">
                            <Placeholder xs={12} bg="dark"></Placeholder>
                          </Placeholder> :
                          <DropDownSelectOfDate time={taskData.time}
                            disabled={getURLPath(location.pathname) === '/statistics'}
                            pickerPosition= {windowScreen > 576 ? 'LeftCenter' : 'Center'} 
                            addTaskButtons 
                            deadlineinput
                            dateStart={getDateObject({dateString: taskData.date})}
                            repeatPayload={
                              {isRepeatTemplate: true,
                                templateData: taskData ?? taskData,
                                templateUpdateFunction: updateRepeatTemplate}
                            } 
                            getDatePayload={updateDataDate}
                            pushDataTime={updateDataTime}
                            />
                      }
                    </li>
                    <li className="priority-item">
                      <p className="modal-label">Приоритет</p>
                      {
                        loading ?
                          <Placeholder animation="wave">
                            <Placeholder xs={12} bg="dark"></Placeholder>
                          </Placeholder> :
                          <button onClick={() => setMenuActivPriorityPicker(true)}
                            disabled={disabled ? disabled : disablePriority}
                            ref={refClosePriorityPicker}
                            className={classPriorityArray[taskData.priority]}>
                            {namesPriorityArray[taskData.priority]}
                          </button>
                      }
                      <DDSelectPriority active={menuActivPriorityPicker}
                        setActive={setMenuActivPriorityPicker}
                        priority={namesPriorityArray[taskData.priority]}
                        updateDataPriority={updateDataPriority} />
                    </li>
                    {
                      prodHidden && 
                      <li className="priority-item">
                        <p className="modal-label">Напоминания</p>
                        {
                          loading ?
                            <Placeholder animation="wave">
                              <Placeholder xs={12} bg="dark"></Placeholder>
                            </Placeholder> :
                            <ReminderSelect textPosition={windowScreen > 576 ? "center" : "start"}  disabled={getURLPath(location.pathname) === '/statistics'} placementVariant="editTask" sizeBtn="md" value={taskData.notificationType} onClickFunc={updateNotifyType}/>  
                        }
                      </li>
                    }
                    <li className="priority-item">
                      <p className="modal-label">Метки</p>
                      {
                        loading ? null :
                        <>
                          {
                            windowScreen > 576 ?
                              <button id='tags'
                                name='tags'
                                style={loading & windowScreen < 576 ? { display: "none" } : null}
                                className="priority__input-tags-modal priority__input-modalwindow"
                                disabled={loading ? true : disabled ? disabled : disablePriority}
                                ref={refCloseTagsPicker}
                                onClick={() => setMenuActivTagsPicker(true)}>
                                Добавить метку
                              </button> :
                              <div className="add-task__change-group__tags"
                                onClick={() => setMenuActivTagsPicker(true)}
                                ref={refCloseTagsPicker}
                                style={{
                                  width: 'auto',
                                  height: '32px',
                                  fontSize: '12px',
                                  justifyContent: 'flex-start',
                                  borderRadius: '8px',
                                  margin: 0,
                                  gap: '4px',
                                  color: '#232360',
                                  border: menuActivTagsPicker ? '1px solid #5932EA' : null,
                                  transition: 'border 0.3s ease-in-out'
                                }}>
                                <span className="add-task__add-tags-to-task"
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                    backgroundRepeat: 'no-repeat',
                                    margin: 0,
                                    backgroundColor: taskData.tags.length === 0 ? '#232360' : '#5932EA'
                                  }} />
                                <p>Метки</p>
                              </div>
                          }
                        </>
                      }
                      {
                        menuActivTagsPicker && 
                        <DDSelectTags active={menuActivTagsPicker}
                          setActive={setMenuActivTagsPicker}
                          taskId={params.id}
                          updateTagList={updateTagList}
                          tagsInList={taskData.tags}
                          removeTagFromTagList={removeTagFromTask}
                        />
                      }
                      {
                        loading ?
                          <Placeholder animation="wave">
                            <Placeholder xs={12} bg="dark"></Placeholder>
                          </Placeholder> :
                          <ul className='test-block ym-hide-content'>
                            {taskData.tags ? taskData.tags.map((el, index) =>
                              <li key={index} className="priority__tags-item" title={el.tagName}>

                                <p className="priority__tags-title">{el.tagName}</p>
                                <span className="priority__remove-tag"
                                  onClick={() => removeTagFromTask(el.tagId)}
                                />
                              </li>) : null}
                          </ul>
                      }
                    </li>
                  </ul>
                </div>
                {
                  loading ? null :
                  <>
                    {
                      windowScreen > 576 ? null :
                        <div className="checklist-container" style={windowScreen > 576 ? { display: "none" } : { display: "block" }}>
                          <div className="checklist-box">
                            <div className="checklist-box__info">
                              <p className="checklist-box__title">Чек-лист</p>
                              { checkList.length > 0 && <span className={controlBtnsCheckList ? 'checklist-box__list-arrow active-btn' : 'checklist-box__list-arrow'}
                                  ref={refCloseControlBtnsCheckList}
                                  onClick={(e) =>{getURLPath(location.pathname) === '/statistics' ? e.preventDefault() 
                            : setControlBtnsCheckList(!controlBtnsCheckList)}} />}
                            </div>
    
                            <DDSelectActionToCheckList active={controlBtnsCheckList}
                              setActive={setControlBtnsCheckList}
                              taskId={params.id} />
    
                            {params.id === undefined ?
                              null :
                              <CheckList taskId={params.id} />
                            }
    
                            {flag ?
                              <form onSubmit={(e) => handleSubmitAddCheckListItem(e)}
                                className="addchecklist">
                                <div className="addCheckElement" style={{ width: widthInputTag, height: heightInputTag }}>
                                  <input type='text'
                                    id='checklist'
                                    name='cheklist'
                                    autoComplete="off"
                                    placeholder='Добавить пункт'
                                    value={checkListTitle}
                                    style={{ width: widthInputTag, height: heightInputTag }}
                                    onInput={(e) => resizeTagInput(e)}
                                    className='addCheckElement__input ym-disable-keys'
                                    onChange={e => setCheckListTitle(e.target.value)}
                                    autoFocus
                                    required />
                                </div>
                                <div className="addchecklist__control-btns">
                                  <Button btnType="filled" btnSize="xs" disabled={checkListTitle === ''} onClickFunc={(e) => handleSubmitAddCheckListItem(e)} title="Добавить"/>
                                  <Button btnType="default" btnSize="xs" onClickFunc={() => setFlag(false)} title="Отмена"/>
                                  {/* <button className="addCheckElement__add-btn"
                                    onClick={(e) => { getURLPath(location.pathname) === '/statistics' ? e.preventDefault() : handleSubmitAddCheckListItem(e)}}
                                  >Добавить</button>
                                  <button
                                    className="close-add-task-form addCheckElement__close-btn"
                                    onClick={() => setFlag(false)}
                                  >Отмена
                                  </button> */}
                                </div>
                              </form>
                              :
                              <div style={{marginTop: '10px'}}>
                                <Button stylesContainer={stylesContainer} logo={<Plus width={'10px'} height={'10px'}/>} btnType="transparent" btnSize="xs" onClickFunc={(e) => { getURLPath(location.pathname) === '/statistics' ? e.preventDefault() : setFlag(true)}} title="Добавить пункт"/>
                              </div>
                            }
                          </div>
                        </div>
                    }
                  
                  </>
                }
              </div>
            </Modal.Body>
          </>
        </Modal>
      }
    </>
  )
}

export default EditModalTask;